/**
 * Конфигурация авторизации для 1С
 * 
 * Учетные данные берутся из переменных окружения Vite (VITE_1C_USERNAME, VITE_1C_PASSWORD)
 * или из .env файла.
 * 
 * ВАЖНО: 
 * - Создайте файл .env в корне проекта (скопируйте из .env.example)
 * - Добавьте .env в .gitignore (уже добавлено)
 * - Не коммитьте .env файл в git!
 */

// Функция кодирования строки в Base64 с поддержкой Unicode (кириллицы)
const encodeBase64 = (str: string) => {
  try {
    const bytes = new TextEncoder().encode(str);
    const binString = Array.from(bytes, (byte) => String.fromCodePoint(byte)).join("");
    return btoa(binString);
  } catch (e) {
    console.error("Encoding error:", e);
    return btoa(unescape(encodeURIComponent(str))); // Фоллбэк
  }
};

/**
 * Получает фиксированные учетные данные из переменных окружения
 * @returns Base64-encoded строка (user:password в base64), БЕЗ префикса "Basic ".
 *          Для заголовка используйте getAuthorizationHeader().
 */
export const getFixedAuthToken = (): string | null => {
  const username = import.meta.env.VITE_1C_USERNAME;
  const password = import.meta.env.VITE_1C_PASSWORD;

  if (!username || !password) {
    console.warn('[AuthConfig] VITE_1C_USERNAME или VITE_1C_PASSWORD не установлены в .env файле');
    return null;
  }

  return encodeBase64(`${username}:${password}`);
};

/**
 * Возвращает значение для заголовка Authorization.
 * Если token уже начинается с "Basic ", возвращает как есть; иначе добавляет префикс.
 */
export const getAuthorizationHeader = (token: string | null): string => {
  if (!token) throw new Error("1C credentials not configured.");
  return token.startsWith("Basic ") ? token : `Basic ${token}`;
};

/**
 * Проверяет, настроена ли фиксированная авторизация
 */
export const isFixedAuthConfigured = (): boolean => {
  return !!(import.meta.env.VITE_1C_USERNAME && import.meta.env.VITE_1C_PASSWORD);
};
